<template>
  <div>
    <template v-if="selectedFlag && selected.filter((item) => item.is_counter_dropoff === true).length === 0 && selected.filter((item) => item.fulfillment_provider_metadata !== null).length === 0">
      <shipblu-button id="request-btn-loading" size="small" :textButton="`${$route.name === 'merchant-returns-view' ? $t('Request Return') : $route.name === 'merchant-cash-collections-view'? $t('Collect Request') :  $t('Request Pickup')}`" 
        :iconStyle="{iconPosition:'left', LeftIconName: 'PackageIcon', LeftIconLibrary: 'feather'}" @click="requestPickup()" class="vs-con-loading__container w-full"/>
    </template>
    <template v-else-if="selectedFlag && selected.filter((item) => item.is_counter_dropoff === true).length > 0">
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Selected orders are designated for \'Counter Drop Off.\' Please modify the order type in the \'Order Info\' section.')}`">
        <shipblu-button size="small" :textButton="$route.name === 'merchant-returns-view' ? $t('Request Return') : $route.name === 'merchant-cash-collections-view'? $t('Collect Request') :  $t('Request Pickup')" 
          :iconStyle="{iconPosition:'left', LeftIconName: 'PackageIcon', LeftIconLibrary: 'feather'}" :disabled="true" class="w-full"/>
      </vx-tooltip>
    </template>
    <template v-else-if="selectedFlag && selected.filter((item) => item.fulfillment_provider_metadata !== null).length > 0">
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Selected orders are designated for \'Fulfillment.\' Please modify the order type in the \'Order Info\' section.')}`">
        <shipblu-button size="small" :textButton="$route.name === 'merchant-returns-view' ? $t('Request Return') : $route.name === 'merchant-cash-collections-view'? $t('Collect Request') :  $t('Request Pickup')" 
        :iconStyle="{iconPosition:'left', LeftIconName: 'PackageIcon', LeftIconLibrary: 'feather'}" :disabled="true" class="w-full"/>
      </vx-tooltip>
    </template>
    <template v-else>
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Please select the order you want to request!')}`">
        <shipblu-button size="small" :textButton="$route.name === 'merchant-returns-view' ? $t('Request Return') : $route.name === 'merchant-cash-collections-view' ? $t('Collect Request') :  $t('Request Pickup')" 
        :iconStyle="{iconPosition:'left', LeftIconName: 'PackageIcon', LeftIconLibrary: 'feather'}" :disabled="true" class="w-full"/>
      </vx-tooltip>
    </template>
  </div>
</template>

<script>
import common from '../../../assets/utils/common'
import {sendRequest} from '../../../http/axios/requestHelper.js'
import i18nData from '../../../i18n/i18nData'

export default {
  props: ['selected'],
  data () {
    return {
      selectedFlag: false,
      merchant: {},
      merchantUpdated: false
    }
  },
  watch: {
    selected (val) {
      if (val.length !== 0 && val.filter(item => item.status === 'created' || item.status === 'pickup_rescheduled').length !== 0) {
        this.selectedFlag = true
      } else {
        this.selectedFlag = false
      }
      this.$emit('selected', val)
    },
    merchantUpdated () {
      const merchantData = common.checkMerchantInLocalStorage(this)
      merchantData.then(results => {
        this.merchant = results.merchantData
      })
    }
  },
  methods: {
    requestPickup () {
      if (this.merchant.is_self_signup === true && this.merchant.name === 'Entrepreneur Merchant') {
        this.$router.push({ name: 'merchant-complete-profile' })
          .catch(() => {})
      } else {
        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: '#request-btn-loading',
          scale: 0.45
        })
        const trackings = []
        let url = ''
        this.selected.forEach(element => {
          if (element.status === 'created' || element.status === 'pickup_rescheduled') {
            if (this.$route.name === 'merchant-cash-collections-view') {
              url = 'api/v1/tracking/cash-collections/'
              trackings.push({
                cash_collection_request:element.id,
                packages: element.packages.map(item => item.package.id),
                status: 'collection_requested'
              })
            } else {
              url = 'api/v1/tracking/'
              trackings.push({
                order:element.id,
                packages: (element.packages || []).map(item => item.package && item.package.id),
                status: this.$route.name === 'merchant-returns-view' ? 'return_requested' : 'pickup_requested'
              })
            }
          }
          if (this.$route.name === 'merchant-cash-collections-view') {
            url = 'api/v1/tracking/cash-collections/'
          }
        })
        sendRequest(true, false, this, url, 'post', trackings, true,
          () => {
            this.$vs.notify({
              color:'success',
              title: i18nData[this.$i18n.locale]['Success'],
              text: i18nData[this.$i18n.locale]['Sent a pickup request. You will receive a notification once done.'],
              position: 'top-center'
            })
            this.$vs.loading.close('#request-btn-loading > .con-vs-loading')
            this.$emit('loadShipments')
            this.$emit('selected', [])
          },
          (error) => {
            common.notifyResponseError(this, error)
            this.$vs.loading.close('#request-btn-loading > .con-vs-loading')
          }
        )
      }
    },
    goToAddTaxProfile () {
      this.$router.push({
        name: 'merchant-profile',
        params: {
          tab: 'tax-profile'
        }
      }).catch(() => {})
    }
  },
  created () {
    const merchantData = common.checkMerchantInLocalStorage(this)
    merchantData.then(results => {
      this.merchant = results.merchantData
    })
  }
}
</script>